import PerfectScrollbar from 'perfect-scrollbar';
jQuery(function ($) {
	if ($('.js-scroll-bar').length) {
    var ps = new PerfectScrollbar('.js-scroll-bar');
	}
});
